import { Controller } from "@hotwired/stimulus"

// Shows length and timeframe for Advancing/Lapsing, and the scale,
// decay, rebound, stress, and morale fields for assets and liabilities.
const PROGRESS_DEFAULTS = { advancing: "Advancing", lapsing: "Lapsing" }
const END_DEFAULTS = { advancing: "Complete!", lapsing: "Lapsed" }

export default class extends Controller {
  static targets = ["leveled", "clock", "progressLabel", "endLabel"]

  connect() {
    this.previousKind = this.selectedKind()
    this.update()
  }

  update() {
    const kind = this.selectedKind()
    const clock = kind === "advancing" || kind === "lapsing"

    this.leveledTargets.forEach((el) => this.toggleSection(el, !clock))
    this.clockTargets.forEach((el) => this.toggleSection(el, clock))
    if (clock) this.applyLabelDefaults(kind)

    this.previousKind = kind
  }

  selectedKind() {
    return this.element.querySelector("input[name='tracker[tracker_type]']:checked")?.value
  }

  applyLabelDefaults(kind) {
    if (this.hasProgressLabelTarget) {
      this.fillDefault(this.progressLabelTarget, PROGRESS_DEFAULTS, kind)
    }
    if (this.hasEndLabelTarget) {
      this.fillDefault(this.endLabelTarget, END_DEFAULTS, kind)
    }
  }

  fillDefault(input, defaults, kind) {
    const next = defaults[kind]
    const current = input.value.trim()
    if (current === "") {
      input.value = next
      return
    }

    const previousDefault = defaults[this.previousKind]
    const switchingFromLeveled = this.previousKind !== "advancing" && this.previousKind !== "lapsing"
    const stillADefault = Object.values(defaults).includes(current)
    if (current === previousDefault || (switchingFromLeveled && stillADefault)) {
      input.value = next
    }
  }

  toggleSection(element, visible) {
    element.classList.toggle("d-none", !visible)
    if (element.tagName === "FIELDSET") {
      element.disabled = !visible
      return
    }

    element.querySelectorAll("input, select, textarea").forEach((input) => {
      input.disabled = !visible
    })
  }
}
